/**
 * Fotos fuer die App verkleinern.
 *
 * Originalfotos vom iPad sind mehrere Megabyte gross. Gespeichert wird
 * deshalb ein JPEG mit begrenzter Kantenlaenge – scharf genug zum Lesen,
 * klein genug fuer Geraet und Cloud. Wird es trotzdem zu gross, geht die
 * Qualitaet schrittweise herunter.
 */
export async function shrinkImage(file: File, maxEdge: number, maxChars: number): Promise<string> {
  const url = URL.createObjectURL(file);
  try {
    const img = new Image();
    img.decoding = 'async';
    img.src = url;
    await img.decode();
    const scale = Math.min(1, maxEdge / Math.max(img.naturalWidth, img.naturalHeight));
    const canvas = document.createElement('canvas');
    canvas.width = Math.round(img.naturalWidth * scale);
    canvas.height = Math.round(img.naturalHeight * scale);
    const ctx = canvas.getContext('2d');
    if (!ctx) throw new Error('Kein Zeichenkontext');
    // JPEG kennt keine Transparenz: weisser Grund statt schwarzer Flaechen.
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
    let quality = 0.85;
    let data = canvas.toDataURL('image/jpeg', quality);
    while (data.length > maxChars && quality > 0.4) {
      quality -= 0.1;
      data = canvas.toDataURL('image/jpeg', quality);
    }
    return data;
  } finally {
    URL.revokeObjectURL(url);
  }
}

/** Öffnet die Fotoauswahl (auf dem iPad auch Kamera) für mehrere Bilder. */
export function pickImageFiles(): Promise<File[]> {
  return new Promise((resolve) => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/*';
    input.multiple = true;
    input.style.display = 'none';
    input.addEventListener('change', () => {
      const files = Array.from(input.files ?? []);
      input.remove();
      resolve(files);
    });
    document.body.append(input);
    input.click();
  });
}
